<template>
    <div>
        <div class="modal fade" id="tableModal" tabindex="-1" role="dialog" aria-labelledby="tableModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="tableModalLabel">{{headerTitle}} Table</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <form>

                                <div class="mb-3">
                                    <label for="nameInput">Name</label>
                                    <input type="text" class="form-control" id="nameInput"
                                           placeholder="Name of table" v-model="table.name">
                                </div>

                            </form>

                            <div v-if="table.id" class="p-2">Fields</div>

                            <table v-if="table.id"  class="table table-sm">
                                <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Type</th>
                                    <th scope="col"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="field in table.fields">
                                    <td>
                                        {{field.name}}
                                    </td>

                                    <td>
                                        {{field.field_type}}
                                    </td>

                                    <td>
                                        <a href="javascript:void(0)" @click="onDeleteFieldClick(field.id)">
                                            <i class="fas fa-trash-alt"></i>
                                        </a>
                                    </td>
                                </tr>

                                </tbody>
                            </table>

                            <div v-if="showConfirmAlert" class="alert alert-danger" role="alert">
                                <p>Are you sure you want to delete this field?</p>
                                <p>
                                    <button type="button" class="btn btn-danger" @click="onConfirmedDeleteClick">Yes
                                    </button>
                                    <button type="button" class="btn btn-secondary " @click="showConfirmAlert = false">
                                        No
                                    </button>
                                </p>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">Ok</button>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

    import ModelService from "../services/ModelService";
    import FieldService from "../services/FieldService";
    import ConfirmModal from "./ConfirmModal.vue";

    export default {
        components: {ConfirmModal},
        props: {
            yesEvent: Function,
            table: Object
        },
        computed: {
            headerTitle() {
                return this.table.id ? 'Edit' : 'New'
            }
        },
        data() {
            return {
                model: webase.model,
                tableId: null,
                displayAlert: false,
                showConfirmAlert: false,
                currentFieldId: null,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            // add an event to trigger the parent's "noEvent" once the modal has been hidden
            // $('#tableModal').on('hidden.bs.modal', () => {
            //     this.$emit('noEvent')
            // })
            // // show the modal
            // $('#tableModal').modal('show')
            this.modalElement = document.getElementById('tableModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()
        },
        beforeUnmount() {
            // remove the event
            // $('#tableModal').off('hidden.bs.modal')
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                // hide the modal
                this.currentModal.hide()
            },
            yesHandler(e) {
                let modelData = {
                    name: this.table.name
                }

                if (this.table.id === null) {
                    modelData['app_id'] = this.model.app.id
                }

                let request = {
                    model: modelData
                }

                let service = new ModelService()
                let promise = this.table.id === null ? service.create(request) : service.update(this.table.id, request)

                promise.then((response) => {
                    let savedTable = response

                    console.log('savedTable')

                    if (this.table.id === null) {
                        console.log('new')
                        console.log(this.yesEvent)
                        this.model.app.tables.push(savedTable)

                        // call the parent's "yesEvent"
                        if (this.yesEvent) {
                            console.log('yes')
                            this.yesEvent(savedTable)
                        }

                    } else {
                        webase.utils.array.update(this.model.app.tables, savedTable)
                    }
                }).catch((message) => {
                    console.log('error saving model')
                    console.log(message)
                })

                // hide the modal
                this.noHandler()
            },
            onDeleteFieldClick(fieldId) {
                this.currentFieldId = fieldId
                this.showConfirmAlert = true
            },

            onConfirmedDeleteClick() {
                let fieldService = new FieldService()

                fieldService.remove(this.currentFieldId).then(() => {
                    webase.utils.array.remove(this.table.fields, this.currentFieldId)
                    this.showConfirmAlert = false
                    this.currentFieldId = null
                }).catch((error) => {
                    console.log('Error removing field.')
                    console.log(error)
                    this.showConfirmAlert = false
                })

            }
        }
    }
</script>
